import * as React from "react"

const IconChip = (props) => (
  <svg
    width={8}
    height={8}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m1.5 1.5 5 5M6.5 1.5l-5 5"
      stroke="#141938"
      strokeLinecap="round"
    />
  </svg>
)

export default IconChip
